/** Hostnames that should only serve the paid-ads landing experience. */
const ADS_HOSTS = new Set(['estimate.epichomepros.com']);

export function getHostname(): string {
  if (typeof window === 'undefined') return '';
  return window.location.hostname.toLowerCase();
}

/** True when the app is loaded on an ads-only subdomain. */
export function isAdsHost(hostname = getHostname()): boolean {
  if (!hostname) return false;
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    // Local preview: append ?ads=1 to force ads-only routing
    return new URLSearchParams(window.location.search).get('ads') === '1';
  }
  return ADS_HOSTS.has(hostname);
}
